import {IOnChanges, IOnChangesObject, IOnInit} from "angular";
import {Optional} from "../../../js/util/Optional";
import {UiUtil} from "../../../js/util/UiUtil";

export const UtilisationBar = "tfUtilisationBar";

const template = `
    <uib-progress max="ctrl.max">
        <uib-bar value="ctrl.value">
            <div style="width:100%; height:100%" ng-style="{'background-color' : ctrl.colour}">
                <span ng-hide="ctrl.value < 0.10">{{ctrl.value | percentage:0}}</span>
            </div>
        </uib-bar>
    </uib-progress>
`;

export function utilisationBar() {
    return {
        template,
        bindings: {
            value: "<",
            max: "<",
            inverse: "<"
        },
        controllerAs: "ctrl",
        controller: UtilisationBarController
    };
}

export class UtilisationBarController implements IOnInit, IOnChanges {

    public value: number | null;
    public max: number;
    public inverse: boolean | null;

    public colour: string;

    public $onInit(): void {
        // This default is to align with what the UIB Bar does, not what I think is right
        this.max = Optional.of(this.max).orElse(100);
    }

    public $onChanges(changes: IOnChangesObject): void {
        if (changes.inverse != null) {
            this.inverse = Optional.of(changes.inverse.currentValue).orElse(false);
        }
        if (changes.max != null) {
            this.max = Optional.of(this.max).orElse(100);
        }
        if (changes.value != null) {
            const value = Optional.of(changes.value.currentValue).orElse(0);
            this.value = value;
            const percentage = value / this.max;

            if (this.inverse) {
                this.colour = UiUtil.inversePercentageColour(percentage);
            } else {
                this.colour = UiUtil.percentageColour(percentage);
            }
        }
    }
}
